// extracted by mini-css-extract-plugin
module.exports = {"iconbarContainer":"Techiconbar-module--iconbarContainer--3dDgV","svgSizer":"Techiconbar-module--svgSizer--3LXr4"};